const productData = {

    categories : [
               { name : 'biomedicale', content: 'Biomedicale' },
               { name : 'informatique', content: 'Informatique' },
               { name : 'mobilier', content: 'Mobilier' },
               { name : 'logiciel', content: 'Logiciel' },
            //    { name : 'papiterie', content: 'papiterie' }  
            ],


    subcategories :   [ 
        
               {  category : 'biomedicale', 
                  listItems : [
                                { name : 'equipement laboratoire', content: 'Equipement laboratoire' },
                                { name : 'equipement bloc', content: 'Equipement bloc' },
            
                            ]
                },
                {  category : 'informatique', 
                   listItems: [
                                { name : 'ordinateur', content: 'Ordinateur' },
                                { name : 'ecran', content: 'Écran' },
                                { name : 'imprimante', content: 'Imprimante' },
                                { name : 'scanner', content: 'Scanner' },
                                { name : 'projecteur', content: 'Projecteur' },
                                { name : 'imprimante 3d', content: 'Imprimante 3D' },
                                { name : 'tablette', content: 'Tablette' },
                                { name : 'smartphone', content: 'Smartphone' },
                                { name : 'accessoire', content: 'Accessoire (souris, clavier, casque, pointeur laser de presentation, multiport usb, disque dur, RAM)' },
                                { name : 'telephonie', content: 'Téléphonie' },
                                { name : 'wifi', content: "point d'acces (Wi-Fi)" },
                                { name : 'camera', content: 'Caméra' },
                                { name : 'serveurs', content: 'Serveur' },
                                { name : 'routeur', content: 'Routeur' },
                                { name : 'switch', content: 'Switch' },
                                { name : 'detecteur', content: 'Détecteur' },
                            ]
                },
                {  category : 'mobilier', 
                   listItems : [
                                { name : 'table', content: 'Table' },
                                { name : 'chaise', content: 'Chaise' },
                                { name : 'Armoire', content: 'Armoire' },
                                { name : 'bibliotheque', content: 'bibliotheque' },
                            ]
                },
                {  category : 'logiciel', 
                   listItems : [
                                { name : 'desktop', content: 'Logiciel desktop' },
                                { name : 'web', content: 'Application web' },
                                { name : 'mobile', content: 'Application mobile' },
                            ]
                }

            ]
}


export default productData;